<template lang="pug">
component(mode="edit" v-bind:is="component")
</template>

<script>
import ClientProfile from '@/components/ClientProfile.vue'
import ProfessionalProfile from '@/components/ProfessionalProfile.vue'

import ApiMixin from '@/mixins/ApiMixin.vue'

export default {
  components: {
    ClientProfile,
    ProfessionalProfile
  },
  mixins: [
    ApiMixin
  ],
  computed: {
    component () {
      return this.isClient() ? 'client-profile' : 'professional-profile'
    }
  }
}
</script>
